import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-backup-process-pending-approval-by-operator.module.scss";
import { useOtaBackupProcessPendingApprovalByOperator } from "./use-ota-backup-process-pending-approval-by-operator";
import type { InstallAndActionBlock } from "@src/cloud-connect/ota-update/constants";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface OTABackupProcessPendingApprovalByOperatorProps {
  activeInstallationData: ActiveInstallationProcessPayload | null;
  setInstallAndActionBlock: React.Dispatch<
    React.SetStateAction<InstallAndActionBlock | null>
  >;
}

const cssClassName = "ota-backup-process-pending-approval-by-operator";

export default function OTABackupProcessPendingApprovalByOperator({
  activeInstallationData,
  setInstallAndActionBlock,
}: OTABackupProcessPendingApprovalByOperatorProps) {
  const { texts, handleCancelRequest, isCancelRequestLoading } =
    useOtaBackupProcessPendingApprovalByOperator({
      activeInstallationData,
      setInstallAndActionBlock,
    });

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.title}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {texts.description}
          </span>
        </div>
      </div>

      <OTAInstallActionButton
        text={texts.cancelRequestButtonText}
        variant="secondary"
        fun={handleCancelRequest}
        disabled={isCancelRequestLoading}
      />
    </div>
  );
}
